var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2456 6.11407C10.9065 6.45321 10.3567 6.45321 10.0175 6.11407L6 2.09655L1.98249 6.11407C1.64335 6.45321 1.09349 6.45321 0.754355 6.11407C0.415215 5.77493 0.415215 5.22507 0.754355 4.88593L5.38593 0.254355C5.72507 -0.0847849 6.27493 -0.0847848 6.61407 0.254355L11.2456 4.88593C11.5848 5.22507 11.5848 5.77493 11.2456 6.11407Z",
    fill: "#436094"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.3243e1d8accca66f52300dada2f15f4a.svg";
export { ForwardRef as ReactComponent };